export const environment = {
    production: false,
    configUrl: "assets/config/config.json",
    svgVersion: "1710175012913",
    version: "2026.10.14.2"
};
